import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosMedical } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";
import { resolveMedicalScope } from "./medicalScope";

// GET Family history
export const fetchFamilyHistory = createAsyncThunk(
  "familyHistory/fetch",
  async (target, { rejectWithValue, getState }) => {
    try {
      const { userId, headers } = resolveMedicalScope(getState(), target);
      const { data } = await axiosMedical.get(
        ENDPOINTS.MEDICAL.FAMILY_HISTORY(userId),
        { headers: { Accept: "application/json", ...headers } }
      );
      if (!Array.isArray(data)) {
        return rejectWithValue("Format inattendu (array attendu).");
      }
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Erreur réseau"
      );
    }
  }
);

// POST Family history
export const addFamilyHistory = createAsyncThunk(
  "familyHistory/add",
  async ({ userId, values }, { rejectWithValue }) => {
    try {
      const { data } = await axiosMedical.post(
        ENDPOINTS.MEDICAL.FAMILY_HISTORY(userId),
        values,
        { headers: { "Content-Type": "application/json", Accept: "application/json" } }
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Erreur réseau"
      );
    }
  }
);

// PUT Family history
export const updateFamilyHistory = createAsyncThunk(
  "familyHistory/update",
  async ({ userId, id, values }, { rejectWithValue }) => {
    try {
      const { data } = await axiosMedical.put(
        ENDPOINTS.MEDICAL.UPDATE_FAMILY_HISTORY(userId, id),
        values,
        { headers: { "Content-Type": "application/json", Accept: "application/json" } }
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Erreur mise à jour"
      );
    }
  }
);

// DELETE Family history
export const removeFamilyHistory = createAsyncThunk(
  "familyHistory/remove",
  async ({ userId, id }, { rejectWithValue }) => {
    try {
      await axiosMedical.delete(
        ENDPOINTS.MEDICAL.DELETE_FAMILY_HISTORY(userId, id),
        { headers: { Accept: "application/json" } }
      );
      return id;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Erreur suppression"
      );
    }
  }
);
